export const demoSurveys = [
  {
    id: '6a023b1ada049d7ebee72017',
    title: 'Prioritize a roadmap',
    landingDescription: 'Use quadratic voting to compare feature ideas, backlog items, and product improvements by both popularity and intensity.',
    designerDescription: 'Feature backlog and product feedback',
  },
  {
    id: '680f38261354f9f2000e5db8',
    title: 'Choose a meeting place',
    landingDescription: 'See how a group weighs concrete location options when access, geography, and preference strength all matter.',
    designerDescription: 'Conference location preferences',
  },
  {
    id: '69764360249947669eb93cf8',
    title: 'Allocate a shared budget',
    landingDescription: 'Explore public priorities and scarce-resource trade-offs with a quadratic survey.',
    designerDescription: 'Community budget tradeoffs',
  },
];
